import angular from 'angular';
import uiRouter from 'angular-ui-router';
import inceptionHeaderComponent from './inceptionHeader.component';

let inceptionHeaderModule = angular.module('inceptionHeader', [
  uiRouter
])

.component('inceptionHeader', inceptionHeaderComponent)

.name;

export default inceptionHeaderModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/managerAsEmployeeCalendarMobile/inceptionHeader/inceptionHeader.js